// Scrollbars sit inside the viewport window.innerWidth and innerHeight report,
// but outside the box the layout is measured into. This body overflows often
// enough for the ~17px difference to decide whether a pane fits.
export const layoutWidth = () => document.documentElement.clientWidth
export const layoutHeight = () => document.documentElement.clientHeight
